export default "__VITE_ASSET__dG2meOSq__"